import { render, staticRenderFns } from "./CbtQuestions.vue?vue&type=template&id=f36e3260"
import script from "./CbtQuestions.vue?vue&type=script&lang=js"
export * from "./CbtQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports